.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-3);
  margin-top: var(--sp-6);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border);
}

.hint {
  margin-top: var(--sp-2);
  color: var(--text-3);
  font-size: var(--fs-sm);
}
